import { seriesStats } from "@/mocks/content";

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[560px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20artistic%20background%20of%20flowing%20golden%20amber%20and%20deep%20teal%20organic%20shapes%20on%20warm%20cream%20paper%20texture%2C%20soft%20gradient%20light%2C%20elegant%20editorial%20composition%2C%20theme%20of%20knowledge%20and%20learning%2C%20high%20detail&width=1920&height=1080&seq=secret-hero-main&orientation=landscape"
          alt="秘密教学系列主视觉背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/70 to-foreground-950/45"></div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-16 py-24 md:py-28">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 text-background-50 text-xs md:text-sm font-label border border-background-50/25 backdrop-blur">
            <i className="ri-verified-badge-line"></i>
            秘密教学系列 · 课程与资源汇总
          </span>

          <h1 className="mt-5 font-heading font-black text-3xl md:text-5xl lg:text-[3.4rem] leading-tight text-background-50">
            从第一课到完整版的
            <br className="hidden sm:block" />
            秘密教学系列课程目录
          </h1>

          <p className="mt-5 text-sm md:text-base leading-relaxed text-background-100/90 max-w-2xl font-body">
            本页把整个「秘密教学」系列按课程目录重新整理，从第 01 课到完整版合辑，
            逐条标注主题、时长与形式，并集中收录对应的教学视频资源。
            想快速定位某一集、想弄清系列结构、想找系统学习顺序——从这里开始就好。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#catalog"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm md:text-base font-label font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-list-check-2"></i>
              查看课程目录
            </a>
            <a
              href="#lessons"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/10 text-background-50 border border-background-50/40 text-sm md:text-base font-label font-medium hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer backdrop-blur"
            >
              <i className="ri-search-eye-line"></i>
              按关键词找课程
            </a>
          </div>

          <dl className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-5 max-w-2xl">
            {seriesStats.map((stat) => (
              <div key={stat.id} className="border-l border-background-50/25 pl-3">
                <dt className="font-heading text-xl md:text-2xl font-bold text-background-50">
                  {stat.value}
                </dt>
                <dd className="mt-0.5 text-xs md:text-sm text-background-100/80 font-label">
                  {stat.label}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}